<template>
    <Loading :loading="loading" :inset="true" :text="$t('logging_in') + '...'">
        <form @submit.prevent="checkoutLogin()" class="relative">
            <SectionWrapper borderPosition="bottom" id="account">
                <template #title>
                    {{ $t('account_login') }}
                    <p class="text-blue text-xs cursor-pointer" @click="$router.push('forgot-password')">
                        {{ $t('forgot_password') }}
                    </p>
                </template>

                <template #content>
                    <!-- Prominent login headline START-->
                    <!-- <div class="bg-red text-white rounded-md w-full p-2 mb-8">
                        <p>
                            <strong>Für Bestandskunden:</strong>
                            <br/>
                            Bitte benutzen Sie beim erstmaligen Einloggen die „Passwort vergessen“-Funktion und legen Sie ein neues Passwort fest um zu Ihrem Dashboard zu gelangen.
                        </p>
                    </div> -->
                    <!-- Prominent login headline END-->

                    <div class="grid grid-cols-1 lg:grid-cols-2 gap-2 lg:-mt-2">
                        <Input type="text" name="email" :formComponentId="this.$.uid" :label="$t('email_adress')" v-model:value="user.email" autocomplete="email"> </Input>
                        <Input
                            type="password"
                            name="password"
                            :formComponentId="this.$.uid"
                            :label="$t('account_password')"
                            v-model:value="user.password"
                            autocomplete="current-password"
                        >
                        </Input>
                        <Checkbox name="remember" :formComponentId="this.$.uid" :label="$t('remember_me')" v-model:value="user.remember"> </Checkbox>
                    </div>

                    <FormButton type="submit" class="my-6" :formComponentId="this.$.uid" styling="primary flex items-center gap-3" :value="$t('account_login')" :disabled="loading">
                        <FontAwesomeIcon
                            v-show="loading"
                            :icon="['fas', 'circle-notch']"
                            class="animate-spin text-white transition-all ease-in-out duration-300 w-0"
                            :class="loading ? 'w-10' : ''"
                        >
                        </FontAwesomeIcon>
                    </FormButton>
                </template>
            </SectionWrapper>
        </form>
    </Loading>
</template>

<script>
export default {
    props: {
        showLinks: Boolean
    },

    data: () => ({
        user: {},
        loading: false
    }),

    methods: {
        checkoutLogin() {
            this.$store.commit('error/unsetByComponentId', this.$.uid);
            this.loading = true;
            this.user.config = { componentId: this.$.uid };
            this.$store
                .dispatch('user/login', this.user)
                .then((response) => {
                    window.scrollTo(0, 0);
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                });
        }
    }
};
</script>
